"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tooltip_1 = require("@nerdwallet/currency/components/Tooltip");
var Help_1 = __importDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Help"));
var variables_1 = require("../../styles/variables");
var Tooltip = function (props) { return (react_1.default.createElement(Tooltip_1.Tooltip, __assign({}, props),
    react_1.default.createElement(Help_1.default, { color: variables_1.colors["green-darkest"] }))); };
exports.default = Tooltip;
